<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Crear sociedad</h2></v-toolbar-title></pre>
                    </v-toolbar>
                    <v-form class="mt-3">
                        <v-row justify="end">
                            <v-tooltip right style="margin-bottom: 5px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        fab
                                        dense
                                        to="lista-sociedades"
                                        :loading="isloading"
                                        :disabled="isloading"
                                        color="blue"
                                        class="mt-4 mx-3"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon class="white--text"
                                            >mdi-arrow-left-bold-outline</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Volver</span>
                            </v-tooltip>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="sociedad.nombre"
                                    label="Nombre fiscal"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="sociedad.cif"
                                    label="CIF"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-autocomplete
                                    v-model="sociedad.id_provincia"
                                    item-value="id"
                                    item-text="nombre"
                                    :items="provincias"
                                    label="Provincia"
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="sociedad.ciudad"
                                    label="Ciudad"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="sociedad.cp"
                                    type="number"
                                    label="Código postal"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="sociedad.direccion"
                                    outlined
                                    label="Dirección"
                                >
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <router-link to="lista-sociedades">
                                    <v-btn color="red" class="white--text mr-2">
                                        Cancelar
                                    </v-btn>
                                </router-link>
                                <v-btn
                                    v-if="!sociedad.id"
                                    @click="saveSociedad"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Guardar</v-btn
                                >
                                <v-btn
                                    v-if="sociedad.id"
                                    @click="saveSociedad"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text mr-2"
                                    >Actualizar</v-btn
                                >
                                <v-btn
                                    v-if="sociedad.id"
                                    @click="dialog_delete = true"
                                    :disabled="isloading"
                                    color="red"
                                    class="white--text"
                                    >Eliminar</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
        <DeleteDialog
            v-model="dialog_delete"
            @delete="deleteSociedad"
        ></DeleteDialog>
    </v-container>
</template>

<script>
import DeleteDialog from "../../../components/general/dialogs/DeleteDialog.vue";
export default {
    components: {
        DeleteDialog,
    },
    data() {
        return {
            dialog_delete: false,
            sociedad: {},
        };
    },
    watch: {
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
    },
    created() {
        if (this.$route.query.id) {
            this.getSociedad();
        }
    },
    methods: {
        getSociedad() {
            axios
                .get(`api/get-sociedad/${this.$route.query.id}`)
                .then((res) => {
                    this.sociedad = res.data;
                });
        },
        deleteSociedad() {
            axios.get(`api/delete-sociedad/${this.$route.query.id}`).then(
                (res) => {
                    this.$toast.sucs("Sociedad eliminada con éxito");
                    this.dialog = false;
                    this.$router.push("lista-sociedades");
                },
                (err) => {
                    this.$custom_error("Error eliminando la sociedad");
                }
            );
        },
        saveSociedad() {
            axios
                .post("api/save-sociedad", this.sociedad)
                .then((res) => {
                    this.$router.push("lista-sociedades");
                })
                .catch((error) => {
                    //console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },
    },
    filters: {},

    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
    },
};
</script>
